export const TESTIMONIALS = [
    {
        id: "maren",
        title: "Breaking a Three-Generation Silent Treatment",
        author: "Maren S. · Verified Buyer (Ohio, USA)",
        quote: "My mother and my daughter hadn't spoken in nearly five years, and the holiday seasons were pure torture for our family. I didn't want to manipulate anyone, so I chose Mara's Karmic Realignment Ritual to clear the air. I don't know how it worked, but my daughter randomly texted her grandmother out of the blue on her birthday. They met for coffee last week and are actively rebuilding. Mara brought genuine peace back into my home when I thought it was completely impossible.",
    },
    {
        id: "shadows",
        title: "A Divine Alignment Found in the Shadows",
        author: "Anonymous Client · Verified Buyer (California, USA)",
        quote: "I fell in love with my sister's husband, but I knew from day one it was a divine connection meant to happen. I was so scared to open up on social media because of people judging and labeling me the 'other woman,' but Mara Vey made me feel completely safe opening up here with zero judgment. I purchased a back-room reading with Mara and the Ex-Ritual. Two months later, we are happily engaged, and I just found out I am pregnant! If the universe meant for it to be yours, Mara will help you claim it.",
    },
    {
        id: "julian",
        title: "From Stagnant Freelancer to Six-Figure Agency",
        author: "Julian K. · Verified Buyer (Denver, CO)",
        quote: "I had been stuck at the same income cap for three years and felt completely invisible in my industry. I ordered Mara's Ancestral Gold Attunement and a custom career reading. The advice was hyper-specific about shifting my target demographic. Within forty-eight hours of finishing the ritual, an old contact reached out with a corporate retainer that completely doubled my annual revenue. If you are sleeping on your own potential, let Mara open the door for you.",
    },
    {
        id: "backfired",
        title: "The Lies of My Enemy Completely Backfired",
        author: "Verified Client (Texas, USA)",
        quote: "I was losing sleep for months because my partner's bitter ex was trying to ruin our lives with completely fabricated legal attacks and threats to take everything. I felt so isolated because the legal system is so cold. I bought Mara's Truth-Veiling Spell combined with the Binding of Tongues. Within weeks of the ritual, the ex's entire court strategy completely stalled out. It's like the judge suddenly saw right through her bitter narrative. If you are being hunted by someone from your partner's past, do not hesitate. Mara completely blinded my enemy.",
    },
    {
        id: "edwards",
        title: "My Manuscript is Finally Finished",
        author: "T. Edwards · Verified Buyer (Florida, USA)",
        quote: "I was suffering from a massive, debilitating case of writer's block while trying to finish my second novel. My energy felt totally drained. I purchased a Crystal Channeling session with Mara. She identified a massive energy block in my solar plexus. Following her specific ritual instructions, the floodgates opened. I wrote thirty thousand words in two weeks and just submitted the final draft to my publisher. Her work is pure, swift, and completely transformative.",
    },
    {
        id: "nsw",
        title: "He Submitted Entirely and Locked Out the Noise",
        author: "Anonymous · Verified Buyer (Savannah, GA)",
        quote: "My partner has a very intense, chaotic personality, and with all the stress of his past marriage, he was starting to pull away and act out. I was terrified I was going to lose the life I sacrificed everything to build. I swallowed my pride and ordered the Absolute Obsession Compulsion along with a Dominance Command. The shift was instant. It completely bent his willpower back to me. He is now entirely compliant, completely devoted, and the chaotic behavior has stopped. He doesn't look left or right anymore—his eyes are locked solely on me and our future. Mara saved my relationship from the brink of collapse.",
    },
];

export const TestimonialSlider = () => {
    return (
        <section
            data-testid="testimonial-slider"
            className="relative overflow-hidden border-b border-purple-500/15 bg-[#0b031e]/60 py-14 backdrop-blur-sm"
        >
            <p className="eyebrow mb-8 text-center">Client Testimonials · Verified Buyers</p>
            <div
                data-testid="testimonial-marquee-viewport"
                className="marquee-viewport-mask relative mx-auto h-[34rem] max-w-2xl overflow-hidden px-5"
            >
                <div className="marquee-track-vertical flex w-full flex-col">
                    {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
                        <figure
                            key={`${t.id}-${i}`}
                            data-testid={i < TESTIMONIALS.length ? `testimonial-slide-${t.id}` : undefined}
                            className="glass-card mb-6 w-full shrink-0 p-6"
                        >
                            <div className="text-sm tracking-[0.3em] text-[#ffd700]">★★★★★</div>
                            <h3 className="mt-3 font-cinzel text-sm font-semibold leading-snug tracking-wide text-[#f8f7ff]">
                                {t.title}
                            </h3>
                            <blockquote className="mt-3 font-cormorant text-base italic leading-relaxed text-[#e0aaff]/85">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-4 font-cinzel text-[10px] tracking-[0.2em] text-[#c77dff]/70">
                                {t.author.toUpperCase()}
                            </figcaption>
                        </figure>
                    ))}
                </div>
            </div>
        </section>
    );
};
